import {
    forwardRef,
    type ForwardRefRenderFunction,
    type ReactNode,
    type FocusEventHandler,
} from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    children: ReactNode | ReactNode[];
    onBlur?: FocusEventHandler;
};
const DropdownBody: ForwardRefRenderFunction<HTMLDivElement, Props> = (
    { children, onBlur },
    ref
) => (
    <div
        ref={ref}
        onBlur={onBlur}
        className={classnames(dibsCss.relative, dibsCss.overflowYScroll, dibsCss.maxH600px)}
    >
        {children}
    </div>
);

export default forwardRef(DropdownBody);
